import React from "react";

import { Input } from "@/components/ui/input";
import { normalizeSearchText } from "@/utils/stringUtils";

/**
 * Silme onayının ÜÇÜNCÜ adımı: kullanıcı, silinecek kaydın adını elle yazar.
 *
 * Tek tıklık "Evet, Sil" diyalogları kazara silmeyi engellemiyordu — 13 EKİM
 * BAŞKENT PARKI 26.08.2026'da böyle silinip veritabanından elle geri alınmak
 * zorunda kaldı. Bu blok, silme butonunu yazılan metin eşleşene kadar kapalı
 * tutar; yani silme "çöp kutusu → adı yaz → onayla" şeklinde üç bilinçli adım
 * gerektirir.
 *
 * Kullanım: metni çağıran tarafta state'te tut, `deleteNameMatches` ile butonu
 * kilitle, diyalog her açılıp kapandığında metni sıfırla (aksi hâlde önceki
 * kaydın adı kutuda kalıp onayı anlamsızlaştırır).
 */

/**
 * Yazılması beklenen metin. Kaydın adı yoksa (boş/eksik veri) kullanıcıyı
 * silme yapamaz hâle düşürmemek için "SİL" kelimesine düşülür — bariyer korunur.
 */
export function deleteConfirmTarget(name) {
  const trimmed = String(name ?? "").trim();
  return trimmed || "SİL";
}

/**
 * Yazılan metin hedefle eşleşiyor mu? normalizeSearchText sayesinde büyük/küçük
 * harf ve Türkçe karakter farkı affedilir, ama metin TAM yazılmalıdır.
 */
export function deleteNameMatches(typed, name) {
  return (
    normalizeSearchText(typed) === normalizeSearchText(deleteConfirmTarget(name))
  );
}

export default function DeleteNameConfirm({
  name,
  value,
  onChange,
  // "parkın adını", "bölgenin adını" gibi — cümleye oturan tamlama.
  label = "kaydın adını",
  placeholder = "Yukarıdaki metni buraya yazın",
}) {
  const target = deleteConfirmTarget(name);
  const matched = deleteNameMatches(value, name);
  const typedSomething = String(value ?? "").trim() !== "";

  return (
    <div className="rounded-md border border-red-200 bg-red-50 p-3 space-y-2">
      <p className="text-sm text-red-800">
        Onaylamak için {label} <span className="font-semibold">birebir</span> yazın:
      </p>
      <p className="select-all rounded border border-red-200 bg-white px-2 py-1 font-mono text-sm text-gray-900 break-words">
        {target}
      </p>
      <Input
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label="Silmeyi onaylamak için adı yazın"
        autoComplete="off"
        className={matched ? "border-green-500 bg-green-50" : ""}
      />
      {!matched && typedSomething && (
        <p className="text-xs text-red-600">Yazdığınız metin eşleşmiyor.</p>
      )}
    </div>
  );
}
